import React, { useContext, useEffect, useState } from "react";
import { Button, Form, FormGroup, FormLabel } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { ErrorAlert } from "../../Components/ErrorAlert";
import { Field, FormikProvider, useFormik } from "formik";
import Shopkeeper from "../../Services/shopkeeperServices";
import Shop from "../../Services/shopServices";
import FormSelectField from "../../Components/FormSelectField";
import { AuthContext } from "../../Auth/Context/AuthContext";
import { message } from "antd";
import TitleHeader from "../accounts/Components/TitleHeader";
function AddShopKeeper(props) {
  const { edit } = props;
  const { user } = useContext(AuthContext);
  const shopKeeperId = useParams().id;

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const [freeShops, setFreeShops] = useState([]);
  const getShopKeeperEdit = async () => {
    if (shopKeeperId) {
      setLoading(true);
      await Shopkeeper.getOne(shopKeeperId)
        .then((data) => {
          console.log("___ Shopkeeper", data.data);

          setFieldValue("name", data.data.name);
          setFieldValue("phone", data.data.phone);
          setFieldValue("address", data.data.address);
          setFieldValue("father_name", data.data.father_name);
          setFieldValue("email", data.data.email);
          setFieldValue("payment_type", data.data.payment_type);
          setFieldValue("payment_period", data.data.payment_period);
          setFieldValue("ownership", data.data.ownership);
          setFieldValue("shops", data.data.shops[0].id);
          setFieldValue(
            "start_date",
            new Date(data.data.data.contract?.start_date)
          );
          setFieldValue("period", data.data.data.contract?.period);
          setFieldValue(
            "contract_type",
            data.data.data.contract?.contract_type
          );
          setLoading(false);
        })
        .catch((err) => {
          setError(true);
          setLoading(false);
          console.log(err);
        });
    }
  };

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      name: "",
      address: "",
      phone: "",
      shops: [],
    },
    onSubmit: (values) => {
      setLoading(true);
      values.branchId = user.branchId;
      if (shopKeeperId) {
        values.id = shopKeeperId;
        Shopkeeper.update(values, shopKeeperId)
          .then((data) => {
            message.success("Updated Successfully");
            navigate("/shopkeeper-list");
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
            message.error("Failed to Save");
          });
      } else
        Shopkeeper.add(values)
          .then((data) => {
            if (data.data.status === "Fail") {
              setLoading(false);
              return message.error("Failed to save");
            }
            setLoading(false);
            message.success("Saved Successfully");
            navigate("/shopkeeper-list");
          })
          .catch((err) => {
            setLoading(false);
            console.log(err);
          });
    },
  });
  const {
    errors,
    touched,
    isSubmitting,
    handleSubmit,
    setFieldValue,
    handleChange,
  } = formik;

  const getAvailableShops = async () => {
    await Shop.getAvailableShops().then((shops) => {
      console.log("Available Free Shops: ", shops.data);
      setFreeShops(shops.data);
    });
  };
  useEffect(() => {
    getShopKeeperEdit();
    getAvailableShops();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        <div class="content">
          <TitleHeader title="Add New Shopkeeper" />
          <div class="card">
            <div class="card-body">
              <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                  <FormGroup className="mb-3">
                    <div class="row">
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Name</FormLabel>
                          <Field
                            type="text"
                            name="name"
                            required
                            placeholder="Name"
                          />
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Email</FormLabel>
                          <Field
                            type="email"
                            name="email"
                            required
                            placeholder="Email"
                          />
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Address</FormLabel>
                          <Field
                            type="text"
                            name="address"
                            required
                            placeholder="Address"
                          />
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Phone</FormLabel>
                          <Field
                            type="text"
                            name="phone"
                            // pattern="^((\+93))(7)([0-9]{8})$"
                            placeholder="07********"
                            required
                          />
                        </div>
                      </div>
                      {/* <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Payment Type</FormLabel>
                          <FormSelectField
                            type="select"
                            name="payment_type"
                            setFieldValue={setFieldValue}
                            required
                          >
                            <option value="">Select</option>
                            <option value="bank">Bank</option>
                            <option value="cash">Cash</option>
                          </FormSelectField>
                        </div>
                      </div> */}

                      <div class="col-lg-12">
                        <Button className="btn btn-submit me-2" type="submit">
                          {shopKeeperId ? "Update" : "Save"}
                        </Button>
                        <a className="btn btn-cancel" href="shopkeeper-list">
                          Cancel
                        </a>
                      </div>
                    </div>
                  </FormGroup>
                </Form>
              </FormikProvider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddShopKeeper;
